import { FuelToast } from '@frete.com/fuel-react'
import styled from 'styled-components'

export const Toast = styled(FuelToast)`
  position: fixed;
  left: 130px;
  z-index: ${({ theme }) => theme.zIndex.toast};
  width: fit-content;

  @media screen and (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    left: 46px;
    bottom: 50px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    transform: translate(-50%, 0%);
    left: 50%;
  }
`
